import { API_CALL } from 'actions/actionConstants'
import type { AppAction } from 'actions/types/ActionTypes'
import { SHOULD_AUTOBATCH } from '@reduxjs/toolkit'
import getMerchandiseByManyIds from 'api/merchandise/getMerchandiseByManyIds'
import { FETCH_MERCHANDISE_BY_IDS } from 'actions/apiActionConstants'
import { unique } from 'lib/array/arrayUtils'

function fetchMerchandiseByIds(ids: Array<string>): AppAction {
  return (dispatch, getState) => {
    const state = getState()

    const missingIds = unique(ids).filter(id =>
      !state.merchandise.merchandise[id] &&
      !state.merchandise.fetchingMerchandise[id] &&
      !state.merchandise.merchandiseErrors[id],
    )

    if (!missingIds.length) {
      return
    }

    dispatch({
      type: API_CALL,
      api: FETCH_MERCHANDISE_BY_IDS,
      meta: {
        [SHOULD_AUTOBATCH]: true,
      },
      request: () => getMerchandiseByManyIds(missingIds),
      ids: missingIds,
    })
  }
}

export default fetchMerchandiseByIds
